'use client';
import { createStyles, getSize, rem } from '@s7/styles';
import { getViewSpec } from '../utils/SelectionControls/getViewSpec.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var iconSizes = {
    xs1: rem(8),
    sm1: rem(10)
};
var controlSizes = {
    xs1: rem(12),
    sm1: rem(16)
};
var borderRadius = rem(3);
var useStyles = createStyles(function(theme, params, param) {
    var size = param.size;
    var controlSize = getSize({
        size: size,
        sizes: controlSizes
    });
    var iconSize = getSize({
        size: size,
        sizes: iconSizes,
        mapper: function(size) {
            return size * 0.625;
        }
    });
    var _getViewSpec = getViewSpec(theme, params, controlSize, borderRadius), label = _getViewSpec.label, input = _getViewSpec.input, icon = _getViewSpec.icon, inner = _getViewSpec.inner;
    return {
        root: _extends({}, theme.fn.typography({
            size: size
        }), {
            position: "relative"
        }),
        inner: inner,
        label: label,
        icon: _extends({}, icon, {
            pointerEvents: "none",
            position: "absolute",
            zIndex: 1,
            margin: "auto",
            opacity: 0,
            transform: "scale(0.75)",
            height: "100%",
            width: iconSize,
            left: "calc(50% - " + iconSize + " / 2)"
        }),
        input: _extends({}, input, {
            appearance: "none",
            margin: "auto"
        })
    };
});

export { useStyles as default };
